/** Formatting shared by the Rent Roll and the Security Deposit Register. */

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "2026-10-13" → "13 Oct 2026". Read from the string itself, so no timezone can move the day. */
export const formatDay = (ymd) => {
  const [y, m, d] = String(ymd || "").slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return "—";
  return `${d} ${MONTHS[m - 1]} ${y}`;
};

export const formatMoney = (n) =>
  n === null || n === undefined || Number.isNaN(Number(n))
    ? "—"
    : new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(Number(n));

/** Today as YYYY-MM-DD in the viewer's own timezone, for a date input's default and max. */
export const todayYmd = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

export const safeFileName = (value) => String(value || "report").replace(/[^a-z0-9_-]+/gi, "_");
